export const SURVEYTYPE_UNKNOWN = 'UNKNOWN';
export const SURVEYTYPE_ONOFF = 'ON-OFF';
export const SURVEYTYPE_ON = 'ON';
export const SURVEYTYPE_DEPOL = 'DEPOL';
export const SURVEYTYPE_NATIVE = 'NATIVE';
export const SURVEYTYPE_DOC = 'DOC';
export const SURVEYTYPE_DCVG = 'DCVG';
export const SURVEYTYPE_ACVG = 'ACVG';
export const SURVEYTYPE_ILI = 'ILI';

export const SURVEY_TYPE_LABELS = {
	[SURVEYTYPE_UNKNOWN]: 'Unknown',
	[SURVEYTYPE_ONOFF]: 'ON / OFF',
	[SURVEYTYPE_ON]: 'ON',
	[SURVEYTYPE_DEPOL]: 'DEPOL',
	[SURVEYTYPE_NATIVE]: 'NATIVE',
	[SURVEYTYPE_DOC]: 'DOC',
	[SURVEYTYPE_DCVG]: 'DCVG',
	[SURVEYTYPE_ACVG]: 'ACVG',
	[SURVEYTYPE_ILI]: 'ILI',
};

export const RE_TEST_SURVEY_FILENAME = {
	[SURVEYTYPE_ONOFF]: /(^|[^a-z])on[^a-z]?off($|[^a-z])/i,
	[SURVEYTYPE_ON]: /(^|[^a-z])on($|[^a-z])/i,
	[SURVEYTYPE_DEPOL]: /(^|[^a-z])depol($|[^a-z])/i,
	[SURVEYTYPE_NATIVE]: /(^|[^a-z])naitive($|[^a-z])/i,
	[SURVEYTYPE_DOC]: /(^|[^a-z])doc($|[^a-z])/i,
	[SURVEYTYPE_DCVG]: /(^|[^a-z])dcvg($|[^a-z])/i,
	[SURVEYTYPE_ACVG]: /(^|[^a-z])acvg($|[^a-z])/i,
	[SURVEYTYPE_ILI]: /(^|[^a-z])ILI($|[^a-z])/i,
};

export const ARR_KEYS_RE_TEST_SURVEY_FILENAME_PRECEDENCE = [
	SURVEYTYPE_ONOFF,
	SURVEYTYPE_ON,
	SURVEYTYPE_DEPOL,
  SURVEYTYPE_NATIVE,
  SURVEYTYPE_DOC,
	SURVEYTYPE_DCVG,
	SURVEYTYPE_ACVG,
	SURVEYTYPE_ILI,
];
